/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.platinium.profil.ts
 *
 * Messages du lot P2, nouveaux champs du profil candidat (formulaire, dépôt du CV, Mon profil) et P1 côté candidat (case de l’accord, historique) (chantier Platinium, cahier des charges
 * app/docs/CDC-PLATINIUM.md).
 *
 * Fichier créé VIDE et déjà branché par la vague 0 (fusionné dans fr.ts,
 * inscrit au garde-fou des sous-catalogues) : l'agent de ce lot n'écrit QUE
 * dans ce fichier. Les textes communs (statut, garde de l'espace, texte de
 * l'accord) sont dans fr.platinium.socle.ts : les réutiliser, ne pas les
 * redéfinir (le garde-fou refuse une clé définie deux fois).
 *
 * Règles : préfixe de clé « platinium.profil. » ; vouvoiement, apostrophes
 * typographiques, aucun tiret cadratin, aucun mot « atelier » en dur, aucun
 * nom, lieu ni type d'événement écrit en dur ({eventTypeDef}).
 *
 * Mikael - chef de projet - 2026-10-14
 */
export const messagesPlatiniumProfilFr: Record<string, string> = {
  // ── Section « Votre profil professionnel » de Mon profil ──────────────
  'platinium.profil.titre': 'Votre profil professionnel',
  'platinium.profil.intro':
    'Ces informations aident les entreprises à repérer les candidatures qui leur correspondent. Tout est facultatif : renseignez ce que vous voulez, et changez-le quand vous voulez.',
  'platinium.profil.majLe': 'Mis à jour le {date}.',
  'platinium.profil.nonRenseigne': 'Non renseigné',
  'platinium.profil.groupe.situation': 'Votre situation',
  'platinium.profil.groupe.souhaits': 'Ce que vous recherchez',
  'platinium.profil.groupe.mobilite': 'Où et comment vous déplacer',
  'platinium.profil.enregistrer': 'Enregistrer mon profil professionnel',
  'platinium.profil.toast.enregistre': 'Votre profil professionnel est enregistré.',
  'platinium.profil.toast.erreur': 'Votre profil n’a pas pu être enregistré. Réessayez dans un instant.',
  'platinium.profil.erreurChamps': 'Vérifiez les champs signalés.',

  // ── Libellés des champs ───────────────────────────────────────────────
  'platinium.profil.champ.situation': 'Vous êtes',
  'platinium.profil.champ.recherche': 'Vous recherchez',
  'platinium.profil.champ.secteur': 'Secteur recherché',
  'platinium.profil.champ.experience': 'Votre expérience',
  'platinium.profil.champ.diplome': 'Votre plus haut diplôme',
  'platinium.profil.champ.domaine': 'Domaine du diplôme',
  'platinium.profil.champ.domaine.aide': 'Par exemple : soudure, comptabilité, aide à la personne.',
  'platinium.profil.champ.contrats': 'Contrats souhaités',
  'platinium.profil.champ.temps': 'Temps de travail souhaité',
  'platinium.profil.champ.dispo': 'Votre disponibilité',
  'platinium.profil.champ.dispoDate': 'Disponible à partir du',
  'platinium.profil.champ.commune': 'Votre commune',
  'platinium.profil.champ.commune.aide':
    'Seul le centre de la commune sert à calculer une distance, jamais votre adresse.',
  'platinium.profil.champ.commune.nonLocalisee':
    'Votre commune est enregistrée, mais sa position n’a pas encore pu être calculée. Elle le sera au prochain enregistrement.',
  'platinium.profil.champ.mobilite': 'Distance que vous acceptez pour un emploi',
  'platinium.profil.champ.permis': 'Permis de conduire',
  'platinium.profil.champ.vehicule': 'Avez-vous un véhicule ?',

  // ── Valeurs ───────────────────────────────────────────────────────────
  'platinium.profil.situation.demandeur_emploi': 'Demandeur ou demandeuse d’emploi',
  'platinium.profil.situation.salarie_reconversion': 'Salarié ou salariée en reconversion',
  'platinium.profil.situation.etudiant': 'Étudiant ou étudiante',
  'platinium.profil.situation.lyceen': 'Lycéen, lycéenne, collégien ou collégienne',
  'platinium.profil.situation.en_formation': 'En formation ou en alternance',
  'platinium.profil.situation.autre': 'Autre',
  'platinium.profil.recherche.emploi': 'Un emploi',
  'platinium.profil.recherche.alternance': 'Une alternance',
  'platinium.profil.recherche.stage': 'Un stage',
  'platinium.profil.recherche.formation': 'Une formation',
  'platinium.profil.recherche.information': 'Je m’informe seulement',
  'platinium.profil.recherche.non': 'Je ne recherche rien de précis',
  'platinium.profil.experience.debutant': 'Débutant ou débutante, sans expérience',
  'platinium.profil.experience.intermediaire': 'Intermédiaire (1 à 3 ans)',
  'platinium.profil.experience.confirme': 'Confirmé ou confirmée (3 à 10 ans)',
  'platinium.profil.experience.expert': 'Expert ou experte (10 ans et plus)',
  'platinium.profil.diplome.sans': 'Sans diplôme',
  'platinium.profil.diplome.cap_bep': 'CAP, BEP (niveau 3)',
  'platinium.profil.diplome.bac': 'Baccalauréat (niveau 4)',
  'platinium.profil.diplome.bac2': 'Bac + 2 : BTS, BUT, DEUST (niveau 5)',
  'platinium.profil.diplome.bac3': 'Bac + 3 : licence (niveau 6)',
  'platinium.profil.diplome.bac5': 'Bac + 5 : master, ingénieur (niveau 7)',
  'platinium.profil.diplome.doctorat': 'Doctorat (niveau 8)',
  'platinium.profil.contrat.cdi': 'CDI',
  'platinium.profil.contrat.cdd': 'CDD',
  'platinium.profil.contrat.interim': 'Intérim',
  'platinium.profil.contrat.alternance': 'Alternance',
  'platinium.profil.contrat.apprentissage': 'Apprentissage',
  'platinium.profil.contrat.stage': 'Stage',
  'platinium.profil.contrat.saisonnier': 'Saisonnier',
  'platinium.profil.contrat.indifferent': 'Peu importe',
  'platinium.profil.temps.plein': 'Temps plein',
  'platinium.profil.temps.partiel': 'Temps partiel',
  'platinium.profil.temps.indifferent': 'Peu importe',
  'platinium.profil.dispo.immediate': 'Immédiate',
  'platinium.profil.dispo.date': 'À partir d’une date',
  'platinium.profil.dispo.preavis': 'En poste, avec un préavis',
  'platinium.profil.dispo.a_preciser': 'À préciser',
  'platinium.profil.mobilite.5': '5 km',
  'platinium.profil.mobilite.10': '10 km',
  'platinium.profil.mobilite.20': '20 km',
  'platinium.profil.mobilite.30': '30 km',
  'platinium.profil.mobilite.50': '50 km',
  'platinium.profil.mobilite.999': 'Toute la région',
  'platinium.profil.mobilite.9999': 'Partout en France',
  'platinium.profil.permis.aucun': 'Aucun permis',
  'platinium.profil.permis.b': 'Permis B',
  'platinium.profil.permis.b_en_cours': 'Permis B en cours',
  'platinium.profil.permis.c': 'Permis C',
  'platinium.profil.permis.ce': 'Permis CE',
  'platinium.profil.permis.d': 'Permis D',
  'platinium.profil.permis.autre': 'Autre permis',
  'platinium.profil.vehicule.oui': 'Oui',
  'platinium.profil.vehicule.non': 'Non',

  // ── « J’ai trouvé un emploi » ─────────────────────────────────────────
  'platinium.profil.enRecherche.titre': 'Disponible pour les recruteurs',
  'platinium.profil.enRecherche.oui':
    'Votre CV peut apparaître dans les recherches des entreprises, selon les accords que vous avez donnés.',
  'platinium.profil.enRecherche.trouve': 'J’ai trouvé un emploi',
  'platinium.profil.enRecherche.trouve.aide':
    'Votre CV sort alors des recherches des entreprises. Celles qui vous suivaient déjà verront que vous avez trouvé un emploi.',
  'platinium.profil.enRecherche.non': 'Vous avez indiqué avoir trouvé un emploi. Votre CV n’apparaît plus dans les recherches des entreprises.',
  'platinium.profil.enRecherche.nonLe':
    'Vous avez indiqué le {date} avoir trouvé un emploi. Votre CV n’apparaît plus dans les recherches des entreprises.',
  'platinium.profil.enRecherche.reprendre': 'Je suis de nouveau disponible',
  'platinium.profil.enRecherche.toast.trouve': 'Bonne nouvelle ! Votre CV n’apparaît plus dans les recherches des entreprises.',
  'platinium.profil.enRecherche.toast.reprendre': 'Vous êtes de nouveau disponible pour les recruteurs.',
  'platinium.profil.enRecherche.toast.erreur': 'Votre choix n’a pas pu être enregistré. Réessayez dans un instant.',

  // ── L’accord Platinium dans Mon profil (le libellé de la case est celui
  //    du socle : platinium.accord.libelle) ─────────────────────────────
  'platinium.profil.accord.titre': 'Recherche Platinium, après {eventTypeDef}',
  'platinium.profil.accord.intro':
    'Certaines entreprises peuvent continuer à rechercher des candidats après {eventTypeDef}. Vous décidez si votre CV en fait partie.',
  'platinium.profil.accord.enregistrer': 'Enregistrer mon accord',
  'platinium.profil.accord.retirer': 'Retirer mon accord',
  'platinium.profil.accord.retrait.avertissement':
    'En retirant votre accord, votre CV sort aussitôt de la recherche Platinium, et tout ce que les entreprises avaient noté à votre sujet est effacé : suivi, notes, entretiens Platinium à venir. Vous pourrez redonner votre accord plus tard.',
  'platinium.profil.accord.ferme':
    'La recherche Platinium n’est pas ouverte en ce moment. Vous pouvez retirer votre accord à tout moment.',
  'platinium.profil.accord.toast.donne': 'Votre accord est enregistré.',
  'platinium.profil.accord.toast.retire':
    'Votre accord est retiré. Tout ce que les entreprises avaient noté à votre sujet a été effacé.',
  'platinium.profil.accord.toast.erreur': 'Votre choix n’a pas pu être enregistré. Réessayez dans un instant.',
  'platinium.profil.accord.erreurDepot':
    'Votre CV est bien déposé, mais votre accord à la recherche Platinium n’a pas pu être enregistré. Vous le retrouverez dans Mon profil.',

  // ── Historique des accords ───────────────────────────────────────────
  'platinium.profil.historique.titre': 'Historique de vos accords',
  'platinium.profil.historique.ligne': '{date} : {quoi} ({source})',
  'platinium.profil.historique.platinium.accorde': 'recherche Platinium accordée',
  'platinium.profil.historique.platinium.retire': 'recherche Platinium retirée',
  'platinium.profil.historique.cv.premium': 'recherche par les entreprises premium accordée',
  'platinium.profil.historique.cv.all': 'CV ouvert à toutes les entreprises',
  'platinium.profil.historique.cv.scanned': 'CV réservé aux entreprises qui scannent votre badge',
};
